import React, { useState, useEffect, useCallback, memo } from 'react';
import './styles/Chatbot.css';
import Sidebar from './Sidebar';
import PromptGuideModal from './PromptGuideModal';
import Chatconversation from "./Chatconversation";
import UserSettings from "./UserSettings";
import ConversationView from "./ConversationView";
import API_CONFIG from './config';

// Home component that now includes all chat functionality
const Home = (handleOpenSupport, handleOpenGraphingBot) => {
  // Chat-related states
  const [userInput, setUserInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [currentConversation, setCurrentConversation] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [signupStep, setSignupStep] = useState(1);
  const [isChatHistoryOpen, setIsChatHistoryOpen] = useState(false);
  const [isLibraryOpen, setIsLibraryOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [isPromptGuideOpen, setIsPromptGuideOpen] = useState(false);
  const [isUserSettingsOpen, setIsUserSettingsOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [currentConversationId, setCurrentConversationId] = useState(null);

  // Scroll-to-top functionality
  const [isVisible, setIsVisible] = useState(false);

  // SVG Icons
  const icons = {
    comments: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>`,
    book: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>`,
    list: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>`,
    history: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M2 12h4M18 12h4M12 2v4M12 18v4" /></svg>`,
    graphing: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 18c1 1 4 2 8 2s7-1 8-2M12 14v4M5 12h14l-2-4H7l-2 4z" /></svg>`,
    settings: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33 1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>`,
    help: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`,
    copy: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>`,
    upload: `<svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="80" /><path d="M57.93 66.2825C55.7706 68.4419 52.9017 69.633 49.8516 69.6278C43.5545 69.6278 38.4278 64.5011 38.4226 58.1989L38.4226 39.577C38.4226 37.3192 39.303 35.196 40.8979 33.6011C42.4929 32.0061 44.6161 31.1258 46.8739 31.1258C49.1317 31.1258 51.2549 32.0061 52.8499 33.6011C54.4449 35.196 55.3252 37.3192 55.3252 39.577L55.3252 57.6707C55.3252 60.5085 53.0208 62.8129 50.183 62.8129C47.3452 62.8129 45.0407 60.5085 45.0407 57.6707L45.0407 41.2963C45.0407 40.2813 45.8589 39.4631 46.8687 39.4683C47.8837 39.4683 48.7019 40.2865 48.6967 41.2963L48.6967 57.6707C48.6967 58.4889 49.3596 59.1517 50.1778 59.1517C50.996 59.1517 51.6588 58.4889 51.6588 57.6707L51.6588 39.577C51.6537 38.298 51.1617 37.0914 50.2606 36.1903C49.3596 35.2893 48.153 34.7869 46.8739 34.7921C44.2329 34.7921 42.089 36.936 42.089 39.577L42.0838 58.2041C42.089 62.4867 45.5689 65.9666 49.8516 65.9718C51.9229 65.9718 53.8804 65.1639 55.3459 63.6984C56.8114 62.2329 57.6193 60.2858 57.6193 58.2041L57.6193 40.5351C57.6193 39.5201 58.4375 38.7019 59.4473 38.7071C60.4623 38.7071 61.2805 39.5253 61.2753 40.5351L61.2753 58.2041C61.2753 61.2594 60.0894 64.1231 57.93 66.2825Z" fill="#2241DD"/></svg>`,
    sends: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="80" height="80" /><circle cx="50" cy="50" r="19" fill="#2241DD"/><path d="M51 46.4142V56.0015C51 56.5529 50.5523 57 50 57C49.4477 57 49 56.5529 49 56.0015V46.4142L46.7071 48.7071C46.3166 49.0976 45.6834 49.0976 45.2929 48.7071C44.9024 48.3166 44.9024 47.6834 45.2929 47.2929L49.2929 43.2929C49.6834 42.9024 50.3166 42.9024 50.7071 43.2929L54.7071 47.2929C55.0976 47.6834 55.0976 48.3166 54.7071 48.7071C54.3166 49.0976 53.6834 49.0976 53.2929 48.7071L51 46.4142Z" fill="none"/><mask id="mask0_321_469" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="45" y="43" width="10" height="14"><path d="M51 46.4142V56.0015C51 56.5529 50.5523 57 50 57C49.4477 57 49 56.5529 49 56.0015V46.4142L46.7071 48.7071C46.3166 49.0976 45.6834 49.0976 45.2929 48.7071C44.9024 48.3166 44.9024 47.6834 45.2929 47.2929L49.2929 43.2929C49.6834 42.9024 50.3166 42.9024 50.7071 43.2929L54.7071 47.2929C55.0976 47.6834 55.0976 48.3166 54.7071 48.7071C54.3166 49.0976 53.6834 49.0976 53.2929 48.7071L51 46.4142Z" fill="white"/></mask><g mask="url(#mask0_321_469)"><rect x="35" y="35" width="30" height="30" fill="white"/></g></svg>`,
    send: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" fill="none"/><circle cx="50" cy="50" r="19" fill="#D9D9D9"/><path d="M51 46.4142V56.0015C51 56.5529 50.5523 57 50 57C49.4477 57 49 56.5529 49 56.0015V46.4142L46.7071 48.7071C46.3166 49.0976 45.6834 49.0976 45.2929 48.7071C44.9024 48.3166 44.9024 47.6834 45.2929 47.2929L49.2929 43.2929C49.6834 42.9024 50.3166 42.9024 50.7071 43.2929L54.7071 47.2929C55.0976 47.6834 55.0976 48.3166 54.7071 48.7071C54.3166 49.0976 53.6834 49.0976 53.2929 48.7071L51 46.4142Z" fill="none"/></mask><g mask="url(#mask0_324_475)"><rect x="35" y="35" width="30" height="30" fill="white"/></g></svg>`,
    sidebar: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" fill="none"/><circle cx="50" cy="50" r="19" fill="#2241DD"/><path d="M52.5858 50L46.2929 43.7071C45.9024 43.3166 45.9024 42.6834 46.2929 42.2929C46.6834 41.9024 47.3166 41.9024 47.7071 42.2929L54.7071 49.2929C55.0976 49.6834 55.0976 50.3166 54.7071 50.7071L47.7071 57.7071C47.3166 58.0976 46.6834 58.0976 46.2929 57.7071C45.9024 57.3166 45.9024 56.6834 46.2929 56.2929L52.5858 50Z" fill="white"/><mask id="mask0_326_484" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="46" y="42" width="9" height="16"><path d="M52.5858 50L46.2929 43.7071C45.9024 43.3166 45.9024 42.6834 46.2929 42.2929C46.6834 41.9024 47.3166 41.9024 47.7071 42.2929L54.7071 49.2929C55.0976 49.6834 55.0976 50.3166 54.7071 50.7071L47.7071 57.7071C47.3166 58.0976 46.6834 58.0976 46.2929 57.7071C45.9024 57.3166 45.9024 56.6834 46.2929 56.2929L52.5858 50Z" fill="none"/></mask><g mask="url(#mask0_326_484)"><rect x="35" y="35" width="30" height="30" fill="none"/></g></svg>`,
    sidebars: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" fill="none"/><circle cx="50" cy="50" r="19" fill="#2241DD"/><path d="M47.4142 50L53.7071 56.2929C54.0976 56.6834 54.0976 57.3166 53.7071 57.7071C53.3166 58.0976 52.6834 58.0976 52.2929 57.7071L45.2929 50.7071C44.9024 50.3166 44.9024 49.6834 45.2929 49.2929L52.2929 42.2929C52.6834 41.9024 53.3166 41.9024 53.7071 42.2929C54.0976 42.6834 54.0976 43.3166 53.7071 43.7071L47.4142 50Z" fill="white"/><mask id="mask0_326_501" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="45" y="42" width="9" height="16"><path d="M47.4142 50L53.7071 56.2929C54.0976 56.6834 54.0976 57.3166 53.7071 57.7071C53.3166 58.0976 52.6834 58.0976 52.2929 57.7071L45.2929 50.7071C44.9024 50.3166 44.9024 49.6834 45.2929 49.2929L52.2929 42.2929C52.6834 41.9024 53.3166 41.9024 53.7071 42.2929C54.0976 42.6834 54.0976 43.3166 53.7071 43.7071L47.4142 50Z" fill="none"/></mask><g mask="url(#mask0_326_501)"><rect x="65" y="65" width="30" height="30" transform="rotate(-180 65 65)" fill="none"/></g></svg>`
  };

  // Function to handle scrolling to the top
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Function to toggle visibility of the "scroll-to-top" button
  const toggleVisibility = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Chat handler functions
  const handleBlur = () => {
    if (!userInput.trim()) {
      setIsTyping(false);
    }
  };

  const handleSignUp = () => {
  };

  const handleSignIn = () => {

  };

  const handleChatClick = () => {
    setIsChatHistoryOpen(prevState => !prevState);
  };

  const handleLibraryClick = () => {
    setIsLibraryOpen(prevState => !prevState);
  };

  const handleCopy = (text) => {
    setCopiedText(text);
    navigator.clipboard.writeText(text)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => console.error("Copy failed:", err));
  };

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    setCurrentConversation(prev => [...prev, { role: 'user', content: userInput }]);
    const currentMessage = userInput;
    setUserInput('');

    try {
      // Simulate API response
      setTimeout(() => {
        setCurrentConversation(prev => [
          ...prev,
          { role: 'bot', content: `Response to: ${currentMessage}` }
        ]);
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error:", error);
      setCurrentConversation(prev => [
        ...prev,
        { role: 'bot', content: "Sorry, something went wrong." }
      ]);
      setIsLoading(false);
    }
  };

  const handleConversationClick = (index) => {
    setCurrentConversation(conversationHistory[index]);
  };

  const handleStartNewChat = () => {
    setCurrentConversation([]);
    setCurrentConversationId(null);
    setSelectedConversation(null);
    setUserInput('');
    
    setTimeout(() => {
      const textarea = document.getElementById("userTextarea");
      if (textarea) {
        textarea.value = '';
      }
    }, 0);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleOpenPromptGuide = () => {
    setIsPromptGuideOpen(true);
  };

  const handleClosePromptGuide = () => {
    setIsPromptGuideOpen(false);
  };

  const handleOpenUserSettings = () => {
    setIsUserSettingsOpen(true);
  };

  const handleCloseUserSettings = () => {
    setIsUserSettingsOpen(false);
  };

  const toggleSidebars = () => {
    setIsClicked(!isClicked);
  };

  const [isChatsOpen, setIsChatsOpen] = useState(false);

  const handleToggleChats = () => {
    setIsChatsOpen(!isChatsOpen);
  };

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handlePromptSelect = (promptText) => {
    setUserInput(promptText);
    setIsPromptGuideOpen(false);
    setTimeout(() => {
      const textarea = document.getElementById("userTextarea");
      if (textarea) {
        textarea.focus();
      }
    }, 0);
  };

  const handleStartConversation = (promptText) => {
    setUserInput(promptText);
    setIsPromptGuideOpen(false);
    // Trigger the send message function after a short delay
    setTimeout(() => {
      handleSendMessage();
    }, 100);
  };

  const handleConversationSelect = (conversation) => {
    setSelectedConversation(conversation);
    setCurrentConversationId(conversation.id || conversation.conversation_id);
  };

  // Handle when a new conversation is created
  const handleConversationCreated = (data) => {
    if (data && (data.id || data.conversation_id)) {
      setCurrentConversationId(data.id || data.conversation_id);
    }
    setRefreshTrigger(prev => prev + 1);
  };

  // Optimized conversation list management - removed to prevent conflicts with new routing
  useEffect(() => {
    // Set up event listener for login events
    const handleLoginSuccess = () => {
      // Clear current conversation state on login
      setCurrentConversation([]);
      setCurrentConversationId(null);
      setSelectedConversation(null);
    };

    window.addEventListener('userLoggedIn', handleLoginSuccess);
    
    // Listen for token refresh events
    const handleTokenRefresh = () => {
      // Token refresh handling
    };
    window.addEventListener('tokenRefreshed', handleTokenRefresh);
    
    // Listen for close sidebar event
    const handleCloseSidebar = () => {
      if (isSidebarOpen) {
        setIsSidebarOpen(false);
      }
    };
    window.addEventListener('closeSidebar', handleCloseSidebar);
    
    // Clean up event listeners
    return () => {
      window.removeEventListener('userLoggedIn', handleLoginSuccess);
      window.removeEventListener('tokenRefreshed', handleTokenRefresh);
      window.removeEventListener('closeSidebar', handleCloseSidebar);
    };
  }, [isSidebarOpen]);

  // Adding the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="chat-app">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        handleChatClick={() => setIsChatHistoryOpen(prev => !prev)}
        handleLibraryClick={() => setIsLibraryOpen(prev => !prev)}
        handleOpenPromptGuide={() => setIsPromptGuideOpen(true)}
        handleOpenUserSettings={handleOpenUserSettings}
        onNewChat={handleStartNewChat}
        onSelectConversation={handleConversationSelect}
        refreshTrigger={refreshTrigger}
        currentConversationId={currentConversationId}
      />

      {selectedConversation ? (
        <ConversationView conversation={selectedConversation} />
      ) : (
        <Chatconversation
          currentConversation={currentConversation}
          setCurrentConversation={setCurrentConversation}
          handleToggleSidebar={handleToggleSidebar}
          userInput={userInput}
          setUserInput={setUserInput}
          isTyping={isTyping}
          setIsTyping={setIsTyping}
          isLoading={isLoading}
          handleOpenPromptGuide={handleOpenPromptGuide}
          handleOpenSupport={handleOpenSupport}
          handleOpenGraphingBot={handleOpenGraphingBot}
          onConversationCreated={handleConversationCreated}
          onNewChat={handleStartNewChat}
          currentConversationId={currentConversationId}
          setCurrentConversationId={setCurrentConversationId}
        />
      )}

      <PromptGuideModal
        isPromptGuideOpen={isPromptGuideOpen}
        handleClosePromptGuide={handleClosePromptGuide}
        handleStartConversation={handleStartConversation}
        currentBotType="knowledge"
      />

      {isUserSettingsOpen && (
        <UserSettings
          isUserSettingsOpen={isUserSettingsOpen}
          handleCloseUserSettings={handleCloseUserSettings}
        />
      )}

      {isVisible && (
        <div
          className="tap-top"
          onClick={handleScrollTop}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: '#2563eb',
            color: '#fff',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          }}
        >
          <i className="fas fa-angle-up"></i>
        </div>
      )}
    </div>
  );
};

export default memo(Home);
